import React from "react";
import {useTranslation} from "react-i18next";
import IconLabel from "./IconLabel";
import PropTypes from "prop-types"
import {BoardType} from "../../model/boardType";

function RequestCard(props) {
  const {t} = useTranslation();
  const boardTypes = BoardType();

  function getBoardType(id) {
    if (!id) {
      return t('request.no_board');
    }
    return boardTypes.filter(board => board.id === id)[0].name;
  }

  return (
    <div className="card is-full-height">
      <header className="card-header has-height-75">
        <p className="card-header-title">
          <span className="icon fz fz-sign-out-alt medium mr-1"/>
          <span>{t("request.request_data")}</span>
        </p>
      </header>
      <div className="card-content">
      <div className="columns">
        <div className="column is-3 info-card-right-border">
          <IconLabel
            label={props.requestDetails && `${props.requestDetails.startDate} : ${props.requestDetails.endDate}`}
            icon={"fz-calendar"}/>
          <IconLabel
            label={props.requestDetails ? `${props.requestDetails.numberOfAdults + props.requestDetails.numberOfChildren} (${t('request.adults')}: ${props.requestDetails.numberOfAdults}, ${t('request.children')}: ${props.requestDetails.numberOfChildren})` : ""}
            icon={"fz-users"}/>
          <IconLabel
            label={props.requestDetails ? `${props.requestDetails.numberOfRooms} ${t('request.rooms')}` : ""}
            icon={"fz-home"}/>
          <IconLabel
            label={props.requestDetails ? `${getBoardType(props.requestDetails.board)}` : t('request.no_board')}
            icon={"fz-fork-knife"}/>
        </div>
        <div className="column is-3">
          <IconLabel
            label={t('request.trail_service.luggage_transport')}
            isCheckbox={true}
            isChecked={props.requestDetails?.trailService.luggageTransport}/>
          <IconLabel label={t('request.trail_service.guide')}
                     isCheckbox={true}
                     isChecked={props.requestDetails?.trailService.guide}/>
          <IconLabel label={t('request.trail_service.back_transfer')}
                     isCheckbox={true}
                     isChecked={props.requestDetails?.trailService.backTransfer}/>
        </div>
        <div className="column is-6">
          <div className="info-card-wrapper">
            <div
              className="has-text-weight-bold">{t("request.deal")}:
            </div>
            <div>{props.requestDetails?.subPackages}</div>
          </div>
          <div className="info-card-wrapper">
            <div
              className="has-text-weight-bold">{t("request.note_from_client")}:
            </div>
            <div>{props.requestDetails?.noteFromClient}</div>
          </div>
        </div>
      </div>
    </div>
</div>
)
}

RequestCard.propTypes = {
  name: PropTypes.object,
  formField: PropTypes.object
};

export default RequestCard;
